export default __webpack_public_path__ + "static/media/CG.018da7e2.svg";